import React from 'react'
import styled from 'styled-components'
import '../css/map-loading-spinner.css'

const ContainerDiv = styled.div`
  position: absolute;
  bottom: 30px;
  left: 10px;
  height: 30px;
  width: 30px;
`

interface IProps {
  visible: boolean
}

class MapLoadingSpinner extends React.Component<IProps> {
  render() {
    if (this.props.visible) {
      return (
        <ContainerDiv>
          <div className="sk-fading-circle">
            <div className="sk-circle1 sk-circle"></div>
            <div className="sk-circle2 sk-circle"></div>
            <div className="sk-circle3 sk-circle"></div>
            <div className="sk-circle4 sk-circle"></div>
            <div className="sk-circle5 sk-circle"></div>
            <div className="sk-circle6 sk-circle"></div>
            <div className="sk-circle7 sk-circle"></div>
            <div className="sk-circle8 sk-circle"></div>
            <div className="sk-circle9 sk-circle"></div>
            <div className="sk-circle10 sk-circle"></div>
            <div className="sk-circle11 sk-circle"></div>
            <div className="sk-circle12 sk-circle"></div>
          </div>
        </ContainerDiv>
      )
    } else {
      return <ContainerDiv />
    }
  }
}

export default MapLoadingSpinner
